import * as React from 'react'

import type { Props } from '../CustomSendRequest/viewModel'

import CustomSendRequest from '../CustomSendRequest'

const CustomSendRequestRequiredMessage = (props: Props) => (
  // @ts-expect-error@2322
  <CustomSendRequest requiredMessage {...props} />
)

export default CustomSendRequestRequiredMessage
